const ACTIVE_KEY = 'activeCompanyId';
const ACTIVE_NAME_KEY = 'activeCompanyName';

export function getActiveCompanyId(user?: { primaryCompanyId?: unknown; companies?: unknown[]; role?: string; companyName?: string } | null): string {
  const home = idOf(user?.primaryCompanyId) || idOf(user?.companies?.[0]);
  if (typeof window === 'undefined') return home;
  const stored = window.sessionStorage.getItem(ACTIVE_KEY) || window.localStorage.getItem('companyId') || '';
  const role = String(user?.role || '').toUpperCase();
  if (user && role !== 'SUPER_ADMIN' && stored) {
    const allowed = new Set(
      [idOf(user.primaryCompanyId), ...(user.companies || []).map((company) => idOf(company))].filter(Boolean)
    );
    if (allowed.size > 0 && !allowed.has(stored)) {
      if (!user.companyName) {
        window.sessionStorage.removeItem(ACTIVE_NAME_KEY);
        window.localStorage.removeItem('companyName');
      }
      setActiveCompany(home || null, user.companyName);
      return home;
    }
  }
  if (stored) return stored;
  return home;
}

export function getActiveCompanyName(): string {
  if (typeof window === 'undefined') return '';
  return window.sessionStorage.getItem(ACTIVE_NAME_KEY) || window.localStorage.getItem('companyName') || '';
}

/** Drop a switched account so the next login starts on that user's own company. */
export function clearStoredCompany() {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(ACTIVE_KEY);
  window.sessionStorage.removeItem(ACTIVE_NAME_KEY);
  window.localStorage.removeItem('companyId');
  window.localStorage.removeItem('companyName');
}

export function resetActiveCompanyToUser(user?: { primaryCompanyId?: unknown; companies?: unknown[]; companyName?: string } | null) {
  const home = idOf(user?.primaryCompanyId) || idOf(user?.companies?.[0]);
  if (!home) {
    clearStoredCompany();
    return;
  }
  setActiveCompany(home, user?.companyName);
}

export function setActiveCompany(companyId: string | null, name?: string) {
  if (typeof window === 'undefined') return;
  if (!companyId) {
    window.sessionStorage.removeItem(ACTIVE_KEY);
    window.sessionStorage.removeItem(ACTIVE_NAME_KEY);
    return;
  }
  window.sessionStorage.setItem(ACTIVE_KEY, companyId);
  window.localStorage.setItem('companyId', companyId);
  if (name) {
    window.sessionStorage.setItem(ACTIVE_NAME_KEY, name);
    window.localStorage.setItem('companyName', name);
  }
  window.dispatchEvent(new CustomEvent('active-company-changed', { detail: { companyId, name } }));
}

function idOf(value: unknown): string {
  if (!value) return '';
  if (typeof value === 'string') return value;
  const record = value as { _id?: unknown; toString?: () => string };
  if (record._id) return idOf(record._id);
  return record.toString?.() || '';
}
